<angular-editor id="team" [(ngModel)]="content" [config]="editorConfig" (ngModelChange)="contentChanged()"></angular-editor>
